module.exports = __webpack_public_path__ + "img/52.4128ce30.jpg";